import React from "react";

const SIZE_CLASSES = {
  xs: {
    ring: "w-8 h-8",
    border: "border-2",
    reverseBorder: "border-2",
    message: "text-[11px]",
    submessage: "text-[10px]",
    gap: "mt-2",
  },
  sm: {
    ring: "w-12 h-12",
    border: "border-[3px]",
    reverseBorder: "border-[3px]",
    message: "text-xs",
    submessage: "text-[11px]",
    gap: "mt-3",
  },
  md: {
    ring: "w-16 h-16",
    border: "border-t-4 border-b-4",
    reverseBorder: "border-r-4 border-l-4",
    message: "text-sm",
    submessage: "text-sm",
    gap: "mt-4",
  },
  lg: {
    ring: "w-20 h-20",
    border: "border-t-4 border-b-4",
    reverseBorder: "border-r-4 border-l-4",
    message: "text-base",
    submessage: "text-sm",
    gap: "mt-6",
  },
};

/**
 * BluTec Ping theme loader — dual-ring spinner using --blue + --text.
 * Same pattern as the app shell loading in Layout.
 */
export default function ThemeLoader({
  message = "Loading…",
  submessage = "",
  size = "md",
  className = "",
  padded = true,
  spinnerOnly = false,
}) {
  const s = SIZE_CLASSES[size] || SIZE_CLASSES.md;

  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${padded ? "py-12" : ""} ${className}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className={`${s.ring} relative ping-loader`}>
        <div className={`${s.ring} rounded-full ${s.border} animate-spin ping-loader-ring`} />
        <div
          className={`${s.ring} rounded-full ${s.reverseBorder} border-transparent animate-spin absolute top-0 left-0 ping-loader-ring-rev`}
        />
      </div>
      {message && !spinnerOnly && (
        <p className={`${s.gap} font-semibold ping-loader-msg ${s.message}`}>{message}</p>
      )}
      {submessage && !spinnerOnly && (
        <p className={`ping-loader-sub mt-1 font-medium ${s.submessage}`}>{submessage}</p>
      )}
    </div>
  );
}
